import Popup from "@/components/Popup/Popup";
import { Button, FormControl, InputLabel, MenuItem, Select, Stack, TextField } from "@mui/material";
import { FC, useState } from "react";

interface Props {
  open: boolean;
  onClose: () => void;

  // eslint-disable-next-line no-unused-vars
  onCreate: (label: string, role: UserRole, password: string) => Promise<void>;
}

const ROLE_LABELS: Record<UserRole, string> = {
  USER: "Utilisateur",
  SUPERVISOR: "Superviseur",
  ADMIN: "Administrateur",
};

const ROLES: UserRole[] = ["USER", "SUPERVISOR"];

const CreateUserPopup: FC<Props> = ({ open, onClose, onCreate }) => {
  const [label, setLabel] = useState("");
  const [password, setPassword] = useState("");
  const [role, setRole] = useState<UserRole>("USER");
  const [loading, setLoading] = useState(false);

  const handleSubmit = async () => {
    if (!label.trim() || !password.trim()) return;
    setLoading(true);
    try {
      await onCreate(label.trim(), role, password.trim());
      setLabel("");
      setPassword("");
      setRole("USER");
    } catch {
      // error handled by parent
    } finally {
      setLoading(false);
    }
  };

  const handleClose = () => {
    setLabel("");
    setPassword("");
    setRole("USER");
    onClose();
  };

  return (
    <Popup
      open={open}
      onClose={handleClose}
      title="Nouvel utilisateur"
      modalSize={{ width: 400, height: "auto" }}
      actions={
        <Stack direction="row" spacing={1} justifyContent="flex-end">
          <Button onClick={handleClose}>Annuler</Button>
          <Button variant="contained" onClick={handleSubmit} disabled={!label.trim() || !password.trim() || loading}>
            Créer
          </Button>
        </Stack>
      }>
      <Stack spacing={2}>
        <TextField
          label="Label"
          fullWidth
          size="small"
          value={label}
          onChange={(e) => setLabel(e.target.value)}
          autoFocus
        />
        <TextField
          label="Mot de passe"
          type="password"
          fullWidth
          size="small"
          value={password}
          onChange={(e) => setPassword(e.target.value)}
          onKeyDown={(e) => e.key === "Enter" && handleSubmit()}
        />
        <FormControl fullWidth size="small">
          <InputLabel>Rôle</InputLabel>
          <Select<UserRole> label="Rôle" value={role} onChange={(e) => setRole(e.target.value as UserRole)}>
            {ROLES.map((r) => (
              <MenuItem key={r} value={r}>
                {ROLE_LABELS[r]}
              </MenuItem>
            ))}
          </Select>
        </FormControl>
      </Stack>
    </Popup>
  );
};

export default CreateUserPopup;
